function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M640.034133 290.338133c-41.6768 0-80.622933 16.384-109.738667 46.148267L512 355.157333l-18.3296-18.705067c-29.115733-29.730133-68.096-46.148267-109.738667-46.148267-84.6848 0-153.565867 68.949333-153.565867 153.634133 0 42.939733 15.4624 81.8176 43.554133 109.4656l238.011733 237.909333 237.943467-237.7728c28.228267-27.7504 43.690667-66.628267 43.690667-109.602133C793.6 359.253333 724.6848 290.338133 640.034133 290.338133z",
  "p-id": 3489
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M512 0C229.239467 0 0 229.239467 0 512s229.239467 512 512 512 512-229.239467 512-512S794.760533 0 512 0zM785.92 589.9264l-273.954133 273.783467L237.909333 589.755733c-37.7856-37.205333-58.709333-89.019733-58.709333-145.783467 0-112.9472 91.8528-204.834133 204.765867-204.834133 47.2064 0 91.8528 15.803733 128.034133 44.885333 36.181333-29.115733 80.7936-44.885333 128.034133-44.885333 112.9472 0 204.765867 91.886933 204.765867 204.834133C844.8 500.770133 823.9104 552.584533 785.92 589.9264z",
  "p-id": 3490
});

function SvgFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632807080413,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3488,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.476a1778.svg";
export { ForwardRef as ReactComponent };